var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sports-football") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    style: {},
    transform: "matrix(0.654102, 0, 0, 0.614256, 8.214142, 8.384411)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Q3_icons",
    "data-name": "Q3 icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.8,16.2a1.4,1.4,0,0,0-2.1,0l-1.5,1.4-1.4-1.4a1.5,1.5,0,0,0-2.1,2.1l1.4,1.5L24,21.9l-1.4-1.4a1.5,1.5,0,0,0-2.1,2.1L21.9,24l-2.1,2.1-1.5-1.4a1.5,1.5,0,0,0-2.1,2.1l1.4,1.4-1.4,1.5a1.4,1.4,0,0,0,0,2.1,1.5,1.5,0,0,0,1.1.4,1.2,1.2,0,0,0,1-.4l1.5-1.4,1.4,1.4a1.3,1.3,0,0,0,1,.4,1.5,1.5,0,0,0,1.1-.4,1.4,1.4,0,0,0,0-2.1l-1.4-1.5L24,26.1l1.4,1.4a1.6,1.6,0,0,0,1.1.5,1.4,1.4,0,0,0,1-.5,1.4,1.4,0,0,0,0-2.1L26.1,24l2.1-2.1,1.5,1.4a1.2,1.2,0,0,0,1,.4,1.5,1.5,0,0,0,1.1-.4,1.5,1.5,0,0,0,0-2.1l-1.4-1.4,1.4-1.5A1.4,1.4,0,0,0,31.8,16.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44,5.5A1.9,1.9,0,0,0,42.5,4a42,42,0,0,0-9.2-1c-6.6,0-15.2,1.6-22,8.3C.4,22.3,3,38.1,4,42.5A1.9,1.9,0,0,0,5.5,44a42,42,0,0,0,9.2,1c6.6,0,15.2-1.6,22-8.3C47.6,25.7,45,9.9,44,5.5ZM33.8,33.8C29.1,38.6,22.6,41,14.7,41a41.7,41.7,0,0,1-7.1-.6c-.9-5.2-2-17.6,6.6-26.2C18.9,9.4,25.4,7,33.3,7a41.7,41.7,0,0,1,7.1.6C41.3,12.8,42.4,25.2,33.8,33.8Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSports);
export default __webpack_public_path__ + "static/media/sports.877bab8b8b297722122447cbd1b457d6.svg";
export { ForwardRef as ReactComponent };